module.exports = __webpack_public_path__ + "img/tps.6699a45b.jpg";